module.exports = "/wwwroot/img/water_supply_info_page.png?ver=b68aae39";